/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_CHATGROUPS (state, chatgroups) {
    state.chatgroups = chatgroups
  },
  SET_CHATGROUPSTAT (state, chatgroups) {
    state.chatgroupstat = chatgroups
  },
  SET_CHATGROUPMESSAGES (state, chatgroupmessages){
    state.chatgroupmessages = chatgroupmessages
  },
  SET_TRANSLATEDCHATGROUPMESSAGES (state, messages){
    messages.forEach(item=>{
      let msgIndex = state.chatgroupmessages.findIndex((u) => item.msgId == u.id)
      if(msgIndex >= 0){
        state.chatgroupmessages[msgIndex].msgText = item.text
      }
    })
  },
  SET_CHATGROUPMESSAGESADD (state, obj){
    obj.reactionCounts = obj.reactionCounts ? obj.reactionCounts : []
    state.chatgroupmessages.push(obj)
  },
   SET_CHATGROUPMESSAGESMODIFY (state, obj){
    const msgIndex = state.chatgroupmessages.findIndex((u) => u.id == obj.id)
    if(msgIndex >= 0){
      state.chatgroupmessages[msgIndex].msgText = obj.msgText
      state.chatgroupmessages[msgIndex].reactionCounts = obj.reactionCounts
      state.chatgroupmessages[msgIndex].msgType = obj.msgType
    }
    /*else
    {
      SET_CHATGROUPMESSAGESADD(obj)
    }*/
  },
  SET_CHATGROUPMESSAGESREMOVE (state, id) {
    //state.chatgroupmessages.filter((u) => u.id != id)
    const msgIndex = state.chatgroupmessages.findIndex((u) => u.id === id)
    if(msgIndex >= 0)
    state.chatgroupmessages.splice(msgIndex, 1)
  }
}
